let css = require('./layout.css');
let Header = require('../header');
let OrderHeader = require('../../order/header');
let Content = require('../content');
let Auth = require('../../auth');
let ErrorPage = require('../error-page');
let Payment = require('../../payment');
let Footer = require('../footer');

class Layout {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: Layout,
    children: [
        {
            name: 'header',
            component: Header,
            watcher: {
                email: ['user', 'email'],
                links: ['header', 'menu'],
                utm: ['utm'],
                layout: ['layout'],
                isBitrix: ['bitrix', 'isBitrix'],
                isManager: ['user', 'isManager']
            }
        },
        {
            name: 'order-header',
            component: OrderHeader
        },
        {
            name: 'content',
            component: Content,
            watcher: {
                components: ['page', 'components']
            }
        },
        {
            name: 'auth',
            component: Auth
        },
        {
            name: 'error-page',
            component: ErrorPage,
            watcher: {
                errorType: ['errorType'],
                isBitrix: ['bitrix', 'isBitrix']
            }
        },
        {
            name: 'payment',
            component: Payment
        },
        {
            name: 'footer',
            component: Footer,
            watcher: {
                isBitrix: ['bitrix', 'isBitrix'],
                year: ['footer', 'year'],
                utm: 'utm'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/layout/layout/index.js